import { getOneDriveAccount } from '@/lib/api/onedrive.js';

interface ReconnectPollingOptions {
  intervalMs?: number;
  maxAttempts?: number;
}

export async function pollOneDriveReconnect(
  workspaceId: string,
  connectionId: string,
  options: ReconnectPollingOptions = {},
): Promise<boolean> {
  const intervalMs = Math.max(0, options.intervalMs ?? 1_000);
  const maxAttempts = Math.max(1, options.maxAttempts ?? 60);

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const account = await getOneDriveAccount(workspaceId, connectionId);
      if (account?.status === 'active') {
        return true;
      }
    } catch {
      // Authorization is completed outside this window. Transient failures are
      // expected while that callback finishes, so keep the bounded poll alive.
    }

    if (attempt + 1 < maxAttempts) {
      await new Promise<void>((resolve) => {
        window.setTimeout(resolve, intervalMs);
      });
    }
  }

  return false;
}
